import { Box, Divider, Flex, HStack, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiBriefcase } from "react-icons/fi";
import type { PortalSourcingEventDetailDto } from "../../../../autogen/bff-api";
import { getBuyerInitials } from "../utils/displayFormatters";
import { LabelValueGrid } from "./LabelValueGrid";
import { SectionCard } from "./SectionCard";

export const EventBuyerInfo = ({ event }: { event: PortalSourcingEventDetailDto }) => {
  const { t } = useTranslation();

  const rows = [
    { label: t("Organization"), value: event.buyerName },
    event.buyerOrganizationNumber && {
      label: t("Organization number"),
      value: formatOrganizationNumber(event.buyerOrganizationNumber),
    },
  ].filter((row): row is { label: string; value: string } => Boolean(row));

  const hasContact = Boolean(event.buyerContactName);

  return (
    <SectionCard icon={FiBriefcase} title={t("About the buyer")}>
      <Stack spacing="5">
        <LabelValueGrid rows={rows} />

        {hasContact && (
          <>
            <Divider borderColor="smBorder" />
            <Box>
              <Text
                color="smMuted"
                fontSize="xs"
                fontWeight="semibold"
                textTransform="uppercase"
                letterSpacing="wide"
                mb="3"
              >
                {t("Contact person")}
              </Text>
              <HStack spacing="3" align="center">
                <Flex
                  width="40px"
                  height="40px"
                  rounded="full"
                  bg="smPrimarySofter"
                  color="smPrimary"
                  fontSize="sm"
                  fontWeight="bold"
                  align="center"
                  justify="center"
                >
                  {getBuyerInitials(event.buyerContactName ?? "")}
                </Flex>
                <Stack spacing="0">
                  <Text color="smText" fontSize="sm" fontWeight="semibold">
                    {event.buyerContactName}
                  </Text>
                  {event.buyerContactTitle && (
                    <Text color="smMuted" fontSize="xs">
                      {event.buyerContactTitle}
                    </Text>
                  )}
                </Stack>
              </HStack>
            </Box>
          </>
        )}
      </Stack>
    </SectionCard>
  );
};

const formatOrganizationNumber = (orgNumber: string) =>
  orgNumber.replace(/^(\d{3})(\d{3})(\d{3})$/, "$1 $2 $3");
